<template>
      <div class="screen-darken">
        <div class="text-black border border-secondary border-2 p-5 bg-white">
            <div class="d-flex justify-content-center align-items-center">
                <h4 class="text-danger"><i class="fa fa-exclamation-triangle"></i>Validating Authentication Token</h4>
            </div>
            <p >Sorry for the interruption. To continue, verify your network connection and reload this page.</p>
            <div class="d-flex justify-content-center align-items-center">
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { useSessionStore } from '@/stores/SessionStore'

import { defineComponent, onMounted } from 'vue';

export default defineComponent({
    setup() {
        const sessionStore = useSessionStore()
        onMounted(async () => {

        })

        return { sessionStore }
    },
    data() {
      return {
      }
    },
    async mounted(){
    },
    name: 'loading-access-token',
    props: {},
    methods : {

    }
});

</script>


<style scoped lang="scss">
</style>
